import React, { useState } from "react";
import CommonModal from "./CommonModal";
import { TextField, Typography } from "@mui/material";
import closeIcon from "../../assets/close-icon.svg";
import "./staffobservation.scss";
// import good from "../../assets/good.svg";
// import moderate from "../../assets/moderate.svg";
// import bad from "../../assets/bad.svg";
import { useDispatch } from "react-redux";
import { setLoading } from "../state/action/globalAction";
import { addComments } from "../../services/romReports";
import { pageLocale } from "../../utils/locale";
import SnackBar from "../snack-bar/SnackBar";
import { getParams } from "../../utils/helpers";
import MessagePopup from "./MessagePopup";

const StaffObservation = ({
  staffObservation,
  setStaffObservation,
  reportIDData,
}) => {
  const dispatch = useDispatch();
  const [staffData, setStaffData] = useState("");
  // const [staffRate, setStaffRate] = useState("");
  const [messagePopup, setMessagePopup] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState({
    flag: false,
    text: null,
  });

  // const staffRating = [
  //   {
  //     icon: good,
  //     text: "Good",
  //     value: "1",
  //   },
  //   {
  //     icon: moderate,
  //     text: "Moderate",
  //     value: "2",
  //   },
  //   {
  //     icon: bad,
  //     text: "Bad",
  //     value: "3",
  //   },
  // ];
  const { errorCode } = pageLocale("common");
  const openErrorHandleClose = () => {
    setOpenErrorAlert({ flag: false, text: null });
  };
  const { reportId, moduleId } = getParams();
  const { staff_remarks, done, staff_remark_message, enter_here, max_limit } =
    pageLocale("newreport");
  const reportIDHandler = () => {
    if (reportId && reportId !== "latest") {
      return reportId;
    }
    return reportIDData || "latest";
  };
  // const staffRatingHandler = (i) => {
  //   setStaffRate(i);
  // };
  const request = {
    staffObservation: staffData,
    // staffObservationRating: Number(staffRate),
    moduleId: Number(moduleId),
  };
  const staffObservationHandler = () => {
    dispatch(setLoading(true));
    addComments(request, reportIDHandler())
      .then(() => {
        dispatch(setLoading(false));
        setStaffObservation(staffData);
        setMessagePopup(true);
      })
      .catch((err) => {
        if (err.response?.status === 401 || err.response?.status === 403) {
          setOpenErrorAlert({ flag: true, text: errorCode });
        } else {
          setOpenErrorAlert({ flag: true, text: err.response?.data?.message });
        }
        dispatch(setLoading(false));
        setStaffObservation();
      });
  };
  return (
    <>
      <CommonModal
        open={staffObservation}
        onClose={() => setStaffObservation()}
        className="staff-outer-wrapper"
      >
        <div className="staff-main-wrapper">
          <div className="staff-header">
            <Typography className="title">{staff_remarks}</Typography>
            <img
              src={closeIcon}
              alt="close"
              onClick={() => setStaffObservation()}
            />
          </div>
          <TextField
            label={enter_here}
            multiline
            inputProps={{ maxLength: 200 }}
            helperText={max_limit.replace("@@", "200")}
            rows={4}
            className="text-box"
            value={staffData}
            onChange={(e) => setStaffData(e.target.value)}
          />
          {/* <Typography className="desc">
            How would you rate the patient&apos;s mobility health?
          </Typography>
          <div className="health-status">
            {staffRating.map((i, index) => {
              return (
                <div
                  className={`values  ${staffRate === i?.value ? "added" : ""}`}
                  key={index}
                  onClick={() => staffRatingHandler(i?.value)}
                >
                  <img src={i?.icon} alt="good" />
                  <Typography>{i?.text}</Typography>
                </div>
              );
            })}
          </div> */}

          {/* <div className="divider"></div> */}
          <button
            className="done-btn"
            onClick={() => staffObservationHandler()}
            // disabled={staffData === "" || staffRate === ""}
            disabled={staffData.trim() === ""}
          >
            {done}
          </button>
        </div>
      </CommonModal>
      <SnackBar open={openErrorAlert} closeHandler={openErrorHandleClose} />
      <MessagePopup
        messagePopup={messagePopup}
        setMessagePopup={setMessagePopup}
        text={staff_remark_message}
      />
    </>
  );
};

export default StaffObservation;
